
import * as React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { ISetUrl } from "../../AppMain";

interface IServiceMenuProps {
    setUrl:ISetUrl
}

interface IServiceMenuItem{
    className: string
    icon     : string
    iconAlign: 'left'|'top'
    url      : string
    title    : string
}

interface IServiceMenu{
    className: string
    items    : IServiceMenuItem[]
}

interface IServiceMenuState {
}

export default class ServiceMenu extends React.Component<IServiceMenuProps, IServiceMenuState>{

    private menus:Array<IServiceMenu>;

  	constructor(props:IServiceMenuProps){
        super(props);
        this.menus = [
            {
                className: 'col-12',
                items    : [{
                    icon: 'img/service/icons/active_service_icon.png',
                    className: 'highlight',
                    iconAlign: 'left',
                    title: 'Active services',
                    url: '/restaurant/active-offers/'
                }]
            },

            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/service/icons/service_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Services',
                    url      : '/restaurant/offers/'
                }]
            },
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/service/icons/orders_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Orders',
                    url      : '/restaurant/orders/'
                }]
            },

            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/service/icons/working_hours_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Working hours',
                    url      : '/restaurant/opening-hours/'
                }]
            },
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/service/icons/financial_statement_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Financial statement',
                    url      : ""
                    //url      : '/restaurant/financial-statement/'
                }]
            },
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/service/icons/profile_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Profile',
                    url      : '/restaurant/profile/'
                }]
            },
            {
                className: 'col-6',
                items    : [
                    {
                        icon     : 'img/service/icons/users_icon.png',
                        className: 'multiple',
                        iconAlign: 'left',
                        title    : 'Users',
                        url      : '/restaurant/users/'
                    },
                    {
                        icon     : 'img/service/icons/closed_today_icon.png',
                        className: 'multiple',
                        iconAlign: 'left',
                        title    : 'Closed today',
                        url      : ''
                    }
                ]
            }
        ];
    }

    private clickHandler(evt, url:string): void {
        evt.preventDefault();
        if ( url !== '' ) {
            this.props.setUrl(url);
        }
    }


    render() {
        return (
            <div id="service_menu">
               <Header setUrl={this.props.setUrl}/>

               <div className="content_section container">
                    <section className="dashboard_menu">
                        <div className="row">

                            {this.menus.map((menu, index) =>{

                                return(
                                    <div className={menu.className}>
                                        {menu.items.map((item?) => {
                                        let className = item.className+' text-center box_align_'+item.iconAlign;
                                        return(
                                            <div className={className} key={index+'_'}>
                                                <a onClick={ (e) => { this.clickHandler(e, item.url); } } className={item.url===''?'disabled':''}>
                                                    <span>
                                                        <div className="icon_container">
                                                            <img src={item.icon} alt="" />
                                                        </div>
                                                        <div className = "label">
                                                            { item.title }
                                                        </div>
                                                    </span>
                                                </a>
                                            </div>
                                        )

                                    })}
                                    </div>

                                )

                            })}
                        </div>
                    </section>
               </div>
                <Footer setUrl={this.props.setUrl}/>
			</div>
        );
    }
}
